export var API_CONFIG = {
    SKPage_userInfo: {
        version: { android: '1.7.0', ios: '1.7.0' },
        apiName: ['getUserInfo'],
        ignoreToast: true,
        // defaultValue
    },
    SKPage_pageInfo: {
        version: { android: '1.0.0', ios: '1.0.0' },
        apiName: ['getPageInfo'],
        ignoreToast: false,
    },
    SKPage_pop: {
        version: { android: '1.0.0', ios: '1.0.0' },
        apiName: ['pop'],
        ignoreToast: false,
    },
    SKPage_lifeCycle: {
        version: { android: '1.7.0', ios: '1.7.0' },
        apiName: ['onLifecycle', 'offLifecycle'],
        ignoreToast: true,
    },
    SKNavigation_dispatch: {
        version: { android: '1.0.0', ios: '1.0.0' },
        apiName: ['schema'],
        ignoreToast: false,
    },
    SKNavigation_openURL: {
        version: { android: '1.8.0', ios: '1.8.0' },
        apiName: ['openURL'],
        ignoreToast: false,
    },
    SKShare_shareImg: {
        version: { android: '1.4.0', ios: '1.4.0' },
        apiName: ['shareImg', 'shareImage'],
        ignoreToast: false,
    },
    SKShare_shareLink: {
        version: { android: '1.8.0', ios: '1.8.0' },
        apiName: ['shareLink'],
        ignoreToast: false,
    },
    SKHandle_handleNavBar: {
        version: { android: '1.10.0', ios: '1.10.0' },
        apiName: ['setNavbar'],
        ignoreToast: false,
    },
    SKHandle_handleOrientation: {
        version: { android: '1.10.0', ios: '1.10.0' },
        apiName: ['setScreen'],
        ignoreToast: false,
    },
    SKHandle_handleStatusBarAppearance: {
        version: { android: '1.12.0', ios: '1.12.0' },
        apiName: ['setStatusBarStyle'],
        ignoreToast: true,
    },
    SKNavigation_openGallery: {
        version: { android: '1.14.0', ios: '1.14.0' },
        apiName: ['openPhoto'],
        ignoreToast: false,
    },
    SKNetwork_executeUpload: {
        version: { android: '1.14.0', ios: '1.14.0' },
        apiName: ['uploadPhoto'],
        ignoreToast: false,
    },
    SKMessage_register: {
        version: { android: '1.14.0', ios: '1.14.0' },
        apiName: ['on'],
        ignoreToast: false,
    },
    SKMessage_unregister: {
        version: { android: '1.14.0', ios: '1.14.0' },
        apiName: ['off'],
        ignoreToast: false,
    },
    SKMessage_sendMessage: {
        version: { android: '1.14.0', ios: '1.14.0' },
        apiName: ['emit'],
        ignoreToast: false,
    },
};
export var API_NAME_MAP = {};
Object.values(API_CONFIG).forEach(function (item) {
    var apiName = item.apiName;
    (apiName || []).forEach(function (name) {
        API_NAME_MAP[name] = item;
    });
});
